import { render, staticRenderFns } from "./landing-stats.vue?vue&type=template&id=24f8f006&scoped=true&"
import script from "./landing-stats.vue?vue&type=script&lang=js&"
export * from "./landing-stats.vue?vue&type=script&lang=js&"
import style0 from "./landing-stats.vue?vue&type=style&index=0&id=24f8f006&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f8f006",
  null
  
)

export default component.exports